import streching from '../../assets/images/stretching.png';
import { Link } from 'react-router-dom';

function FindOut() {
  return(
    <div className="findout__container full-horizon">
      <div className="findout__wrapper row">
        <div className="findout__content quarter">
          <div className="findout__content-wrapper column">
            <div className="findout__content-title">
              <h1>천연의 건강 보조제에 대한 저희의 약속</h1>
            </div>
            <div className="findout__content-text">
              <p>저희는 자연이야말로 건강의 열쇠를 쥐고 있으며, 저희의 제품들을 통해 최고의 영양제가 공급되길 기대한다고 생각합니다. </p>
              <p>저희는 전 제품에 대해 광범위한 연구조사와 공급망의 관리감독을 통해 고객을 100% 만족시킬 수 있도록 하고자 합니다.  </p>
            </div>
            <div className="findout__content-button">
              <Link to="/commitment">
                <button>더 알아보기</button>
              </Link>
            </div> 
          </div>
        </div>
        <div className="findout__content half">
          <div className="findout__content-center">
            <div className="findout__content-inner column">
              <h1>자연으로부터 온 관절 통증 해소법 - 스스로를 돌보는 것만큼 기쁜 일은 없습니다</h1>
              <div className="findout__center-button">
                <Link to="/products">
                  <button>제품 보기</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="findout__content column quarter">
          <div className="findout__content-image">
            <img src={streching} alt="stretching"/>
          </div>
          <div className="findout__content-wrapper column">
            <div className="findout__content-title">
                <h1>초록입 홍합은?</h1>
              </div>
              <div className="findout__content-text">
                <ol>
                  <li>30가지 이상의 필수 지방산 조합과, 풍부한 GAGs</li>
                  <li>각종 연결 조직과 관절 기능을 지원</li>
                  <li>심장 및 호흡기 건강을 보조</li>
                </ol>
              </div>
              <div className="findout__content-button">
                <Link to="/products/ingredient/greenliipmussel">
                  <button>더 알아보기</button>
                </Link>
              </div> 
          </div>
        </div>
      </div>
    </div>
  );

}

export default FindOut;